<template>
  <div class="d-flex">
    <self-unassign
      class="mx-2"
      v-if="
        assigned &&
          !paused &&
          !rejected &&
          ['1', '2', '3', '5'].includes(status) &&
          (isDispatcher || (isPEM && TPEM))
      "
      :requestId="requestId"
      :groupId="groupId"
      @success="onUnassign"
    />
    <self-assign
      class="mx-2"
      v-else-if="
        !assigned &&
          !rejected &&
          ['1', '2', '3', '5'].includes(status) &&
          (isDispatcher || (isPEM && TPEM))
      "
      :requestId="requestId"
    />
    <self-assign
      class="mx-2"
      v-if="paused && !rejected && status === '1' && isDispatcher"
      :groupId="groupId"
      paused
      :requestId="requestId"
    />
    <request-affectation-btn-dialog
      class="mx-2"
      v-if="!rejected && ['1', '2', '3'].includes(status) && isDispatcher"
      :entity_nav_full_id="entity_nav_full_id"
      :is-assigned="assigned"
      :is-paused="paused"
      :item="item"
      :property-id="propertyId"
      :requestId="requestId"
      :request-ordo="requestOrdo"
      :technician_internal_id="technician_internal_id"
    />
    <workorder-report-btn-dialog
      v-if="
        !rejected &&
          ['1', '2', '3'].includes(status) &&
          (isDispatcher || (isPEM && TPEM))
      "
      class="mx-2"
      :entity_nav_full_id="entity_nav_full_id"
      :is-assigned="assigned"
      :is-paused="paused"
      :is-pem-his="isPEM && TPEM"
      :property-id="propertyId"
      :qualification="qualification"
      :requestId="requestId"
      :request="item"
      :status="status"
      :symptom="symptom"
      :technician_internal_id="technician_internal_id"
    />
    <rejection-btn-dialog
      v-if="
        !rejected &&
          ['1', '2', '3', '5'].includes(status) &&
          (isDispatcher || (isPEM && TPEM))
      "
      :requestId="requestId"
      :is-paused="paused"
      :is-assigned="assigned"
      class="mx-2"
    />
    <pause-btn-dialog
      v-if="!rejected && !paused && status === '1' && isDispatcher"
      :requestId="requestId"
      class="mx-2"
    />
    <LinkToP2O
      v-if="
        requestOrdo &&
          entityOrdo &&
          !rejected &&
          ['1', '2'].includes(status) &&
          isDispatcher
      "
      :request-id="requestId"
      :is-paused="paused"
      :is-assigned="assigned"
      class="mx-2"
    />
    <slot />
  </div>
</template>

<script>
import { AUTHORIZATION_MODULE_PATH } from '@/store/modules/authorization';
import { generateMessage } from '@/utils/i18n';
import LinkToP2O from '@/components/tools/LinkToP2O';
import { mapActions, mapGetters } from 'vuex';
import PauseBtnDialog from '@/pages/eDispatch/requestActions/PauseBtnDialog';
import RejectionBtnDialog from '@/pages/eDispatch/requestActions/RejectionBtnDialog';
import RequestAffectationBtnDialog from '@/pages/eDispatch/requestActions/RequestAffectationBtnDialog';
import SelfAssign from '@/pages/eDispatch/requestActions/SelfAssign';
import SelfUnassign from '@/pages/eDispatch/requestActions/SelfUnassign';
import WorkorderReportBtnDialog from '@/pages/eDispatch/requestActions/WorkorderReportBtnDialog';

export default {
  name: 'RequestActions',
  components: {
    LinkToP2O,
    PauseBtnDialog,
    RejectionBtnDialog,
    RequestAffectationBtnDialog,
    SelfAssign,
    SelfUnassign,
    WorkorderReportBtnDialog,
  },
  computed: {
    ...mapGetters({
      isDispatcher: `${AUTHORIZATION_MODULE_PATH}/isDispatcher`,
      isPEM: `${AUTHORIZATION_MODULE_PATH}/isPEM`,
    }),
  },
  props: {
    assigned: {
      type: Boolean,
      required: false,
      default: false,
    },
    entity_nav_full_id: {
      type: String,
      required: true,
    },
    entityOrdo: {
      type: Boolean,
      required: false,
      default: false,
    },
    groupId: {
      type: String,
      required: false,
    },
    item: {
      type: Object,
      required: false,
    },
    namespace: {
      type: String,
      required: false,
    },
    paused: {
      type: Boolean,
      required: false,
      default: false,
    },
    propertyId: {
      type: Number,
      required: true,
    },
    qualification: {
      type: Number,
      required: false,
    },
    rejected: {
      type: Boolean,
      required: true,
    },
    requestId: {
      type: Number,
      required: true,
    },
    requestOrdo: {
      type: Boolean,
      required: false,
      default: false,
    },
    status: {
      type: String,
      required: true,
    },
    symptom: {
      type: Number,
      required: false,
    },
    technician_internal_id: {
      type: Number,
      required: false,
    },
    TPEM: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    generateMessage,
    ...mapActions('modal', ['showModal']),
    onUnassign(message) {
      this.$emit('unassign', message);
    },
  },
};
</script>

<style scoped></style>
